import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { initPwaListeners, isNativeApp, setUpdateReady } from './utils/pwa';

// Must run before React mounts so an early `beforeinstallprompt` isn't missed.
initPwaListeners();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// The Android (Capacitor) app ships its assets locally; a service worker there only adds stale-cache risk.
if (isNativeApp()) {
  serviceWorkerRegistration.unregister();
} else {
  serviceWorkerRegistration.register({ onUpdate: setUpdateReady });
}
